import script from "./UserCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCenter.vue?vue&type=script&setup=true&lang=js"

import "./UserCenter.vue?vue&type=style&index=0&id=50ab1efe&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50ab1efe"]])

export default __exports__